<template>
  <div class="two-fa-info">
    <form @submit.prevent="$emit('continue')">
      <div class="two-fa-info__content">
        <div class="two-fa-info__icon">
          <svg v-if="header.includes('(2FA)')" width="32" height="32" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3 class="two-fa-info__title">{{ header }}</h3>
        <p class="two-fa-info__text">{{ text }}</p>
        <Btn
          class="two-fa-info__btn"
          :title="header.includes('2FA') ? 'Continue' : 'I have it installed'"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Btn from "@/components/general/BtnComponent.vue";

export default {
  name: "TwoFaInfoForm",

  emits: ["continue"],

  components: {
    Btn,
  },

  props: {
    header: { type: String, default: () => "", required: true },
    text: { type: String, default: () => "", required: true },
  },
};
</script>

<style lang="scss" scoped>
.two-fa-info {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 24px;
  }

  &__icon {
    width: 72px;
    height: 72px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    margin-bottom: 20px;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 12px 0;
  }

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0 0 32px 0;
    line-height: 1.6;
    max-width: 320px;
  }

  &__btn {
    width: 100%;
    max-width: 280px;
  }
}
</style>
